import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=f8985ce6&scoped=true&"
import script from "./footer.vue?vue&type=script&lang=js&"
export * from "./footer.vue?vue&type=script&lang=js&"
import style0 from "./footer.vue?vue&type=style&index=0&id=f8985ce6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!//node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8985ce6",
  null
  
)

export default component.exports